import React from 'react';
import { useAuth } from '../../context/authContext';
import { Calendar, Mail, User as UserIcon } from 'lucide-react';

const Profile = () => {
    const { user } = useAuth();

    if (!user) return <div className="p-6 text-center text-gray-600">Loading user data...</div>;

    const formattedDate = new Date(user.createdAt).toLocaleDateString();

    return (
        <div className="p-8 mt-12 max-w-md mx-auto bg-white shadow-lg rounded-2xl border-t-8 border-red-600">
            <div className="flex flex-col items-center space-y-5">

                {/* Profile Icon */}
                <div className="rounded-full bg-red-600 p-4 flex items-center justify-center shadow-md">
                    <UserIcon className="text-white" size={90} />
                </div>

                {/* Name */}
                <h1 className="text-2xl font-bold text-gray-800">
                    {user.name}
                </h1>

                <div className="flex flex-col items-center space-y-3 w-full">
                    {/* Email */}
                    <div className="flex items-center text-gray-700 text-base">
                        <Mail className="w-5 h-5 mr-2 text-red-600" />
                        {user.email}
                    </div>

                    {/* Join Date */}
                    <div className="flex items-center text-gray-700 text-base">
                        <Calendar className="w-5 h-5 mr-2 text-red-600" />
                        Joined on <span className="ml-1 font-medium">{formattedDate}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;